import classNames from 'classnames';
import React, { useCallback } from 'react';
import { FormControlLabel, makeStyles, RadioGroup } from '@material-ui/core';
import { RadioButton } from 'components/RadioButton/RadioButton';
import i18n from '../../../i18n';
import { WrappedFieldProps } from 'redux-form';

const useClasses = makeStyles(theme => ({
    label: {
        whiteSpace: 'nowrap',
        marginLeft: -theme.spacing(1),
        marginRight: theme.spacing(3),
    },
    optionsContainer: {
        margin: 0,
        display: 'flex',
        [theme.breakpoints.down(395)]: {
            flexDirection: 'column',
        },
    },
    optionsError: {
        color: '#f44336',
    },
}));

export interface PromoOptionGroupFieldProps {
    labelMarker: string;
    values: string[];
}

export const PromoOptionGroupField = (props: PromoOptionGroupFieldProps & WrappedFieldProps) => {
    const {
        input: { value, onChange, name },
        labelMarker,
        values,
        meta: { touched, invalid, error },
    } = props;

    const { t } = i18n.useTranslation();

    const handlePromoDeliveryTypeChange = useCallback(
        (_, value) => {
            onChange(value);
        },
        [onChange],
    );

    const classes = useClasses();
    const errorMessage = touched && invalid ? t(error) : undefined;
    return (
        <RadioGroup name={name} value={value} onChange={handlePromoDeliveryTypeChange}>
            <div className={classes.optionsContainer}>
                {values.map((value, i) => (
                    <div key={i}>
                        <FormControlLabel
                            className={classNames(classes.label, errorMessage && classes.optionsError)}
                            value={value}
                            control={<RadioButton />}
                            label={t(`${labelMarker}.${value}`)}
                        />
                    </div>
                ))}
            </div>
        </RadioGroup>
    );
};
